module.exports = __webpack_public_path__ + "static/media/torso-low-front.db7e09e6.png";